import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';
import { paths } from '@app/routes/paths';

export const NotFoundPage = () => (
  <div className="flex min-h-screen items-center justify-center">
    <Result
      status="404"
      title="404"
      subTitle="This page does not exist."
      extra={
        <Link to={paths.root}>
          <Button type="primary">Go home</Button>
        </Link>
      }
    />
  </div>
);
